import { render, staticRenderFns } from "./BlockedReport.vue?vue&type=template&id=c72645c0&scoped=true&"
import script from "./BlockedReport.vue?vue&type=script&lang=js&"
export * from "./BlockedReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72645c0",
  null
  
)

export default component.exports